// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"143":"app","647":"lib"}[chunkId] || chunkId) + ".css";
};